var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.show
        ? _c(
            "ob1-expanding-accordion-card",
            {
              attrs: {
                "link-id": "link-" + _vm.shelfId,
                "collapsed-block-id": "collapsed-block-" + _vm.shelfId,
                "link-title": _vm.label,
                "is-showed": _vm.isDesktop,
                "is-multi-card": _vm.isMultiShelf,
              },
            },
            [
              _c(
                "ul",
                { staticClass: "items-list" },
                [
                  _c(
                    "li",
                    { staticClass: "mb-1" },
                    [
                      _c("ob1-check-box2", {
                        staticClass: "items-list-item",
                        attrs: {
                          id: _vm.showAllCheckBox.checkBoxId,
                          name: _vm.showAllCheckBox.checkBoxId,
                          label: _vm.showAllCheckBox.label,
                          "is-indeterminated":
                            _vm.showAllCheckBox.isIndeterminated,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.showAllHandler(true)
                          },
                        },
                        model: {
                          value: _vm.showAllCheckBox.isChecked,
                          callback: function ($$v) {
                            _vm.$set(_vm.showAllCheckBox, "isChecked", $$v)
                          },
                          expression: "showAllCheckBox.isChecked",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.checkBoxes, function (category) {
                    return _c(
                      "li",
                      { key: category.checkBoxId, staticClass: "ms-1" },
                      [
                        _c("ob1-check-box2", {
                          staticClass: "items-list-item",
                          attrs: {
                            id: _vm.device + "-" + category.checkBoxId,
                            name: _vm.device + "-" + category.checkBoxId,
                            label:
                              category.label +
                              " (" +
                              category.accessoriesCount +
                              ")",
                            "is-indeterminated": category.isIndeterminated,
                            "is-disabled": category.accessoriesCount === 0,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.categoryHandler(category.seoId, true)
                            },
                          },
                          model: {
                            value: category.isChecked,
                            callback: function ($$v) {
                              _vm.$set(category, "isChecked", $$v)
                            },
                            expression: "category.isChecked",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "items-list" },
                          _vm._l(
                            category.subCategoriesCheckBoxes,
                            function (subCategory) {
                              return _c(
                                "li",
                                {
                                  key: subCategory.checkBoxId,
                                  staticClass: "ms-1 my-1",
                                },
                                [
                                  _c("ob1-check-box2", {
                                    staticClass: "items-list-item",
                                    attrs: {
                                      id:
                                        _vm.device +
                                        "-" +
                                        subCategory.checkBoxId,
                                      name:
                                        _vm.device +
                                        "-" +
                                        subCategory.checkBoxId,
                                      label:
                                        subCategory.label +
                                        " (" +
                                        subCategory.accessoriesCount +
                                        ")",
                                      "is-indeterminated":
                                        subCategory.isIndeterminated,
                                      "is-disabled":
                                        subCategory.accessoriesCount === 0,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.subCategoryHandler(
                                          subCategory.seoId,
                                          true
                                        )
                                      },
                                    },
                                    model: {
                                      value: subCategory.isChecked,
                                      callback: function ($$v) {
                                        _vm.$set(subCategory, "isChecked", $$v)
                                      },
                                      expression: "subCategory.isChecked",
                                    },
                                  }),
                                ],
                                1
                              )
                            }
                          ),
                          0
                        ),
                      ],
                      1
                    )
                  }),
                ],
                2
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }